import styled from 'styled-components';
import { Typography } from 'antd';

const dark = (p: { $isDark?: boolean }) => p.$isDark;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FieldLabel = styled.label<{ $isDark?: boolean }>`
  font-size: 13px;
  font-weight: 500;
  color: ${(p) => (dark(p) ? '#e5e7eb' : '#374151')};
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const PredictionsDropdown = styled.div<{ $isDark?: boolean }>`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 1000;
  background: ${(p) => (dark(p) ? '#1a202c' : '#ffffff')};
  border: 1px solid ${(p) => (dark(p) ? '#30363d' : '#e8e8e8')};
  border-radius: 8px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
`;

export const PredictionItem = styled.div<{ $isDark?: boolean }>`
  padding: 10px 16px;
  cursor: pointer;
  transition: background 0.15s;
  border-bottom: 1px solid ${(p) => (dark(p) ? '#30363d' : '#f0f0f0')};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${(p) => (dark(p) ? '#2d3748' : '#f5f5f5')};
  }
`;

export const PredictionMainText = styled.div`
  font-size: 13px;
  font-weight: 500;
`;

export const PredictionSecondaryText = styled.div`
  font-size: 12px;
  color: #8b949e;
  margin-top: 2px;
`;

export const HintText = styled(Typography.Text)`
  font-size: 12px !important;
  margin-top: 4px;
  display: block;
`;

export const AddressBox = styled.div<{ $isDark?: boolean }>`
  padding: 16px;
  border: 1px solid ${(p) => (dark(p) ? '#30363d' : '#e8e8e8')};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FieldRow = styled.div`
  display: flex;
  gap: 12px;
`;

export const FlexField = styled.div<{ $flex?: number }>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: ${(p) => p.$flex ?? 1};
`;

export const ErrorText = styled.span`
  font-size: 12px;
  color: #ff4d4f;
  margin-top: 2px;
  display: block;
`;
